/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { QuoteTestExecutionAudit } from "./QuoteTestExecutionAudit";
import {
  QuoteTestExecutionAuditFromJSON,
  QuoteTestExecutionAuditFromJSONTyped,
  QuoteTestExecutionAuditToJSON,
  QuoteTestExecutionAuditToJSONTyped,
} from "./QuoteTestExecutionAudit";
import type { QuoteTestExecutionExpectation } from "./QuoteTestExecutionExpectation";
import {
  QuoteTestExecutionExpectationFromJSON,
  QuoteTestExecutionExpectationFromJSONTyped,
  QuoteTestExecutionExpectationToJSON,
  QuoteTestExecutionExpectationToJSONTyped,
} from "./QuoteTestExecutionExpectation";
import type { QuoteTestExecutionType } from "./QuoteTestExecutionType";
import {
  QuoteTestExecutionTypeFromJSON,
  QuoteTestExecutionTypeFromJSONTyped,
  QuoteTestExecutionTypeToJSON,
  QuoteTestExecutionTypeToJSONTyped,
} from "./QuoteTestExecutionType";
import type { QuoteTestResult } from "./QuoteTestResult";
import {
  QuoteTestResultFromJSON,
  QuoteTestResultFromJSONTyped,
  QuoteTestResultToJSON,
  QuoteTestResultToJSONTyped,
} from "./QuoteTestResult";
import type { QuoteTestExecutionExpectationDto } from "./QuoteTestExecutionExpectationDto";
import {
  QuoteTestExecutionExpectationDtoFromJSON,
  QuoteTestExecutionExpectationDtoFromJSONTyped,
  QuoteTestExecutionExpectationDtoToJSON,
  QuoteTestExecutionExpectationDtoToJSONTyped,
} from "./QuoteTestExecutionExpectationDto";
import type { QuoteTestExecutionState } from "./QuoteTestExecutionState";
import {
  QuoteTestExecutionStateFromJSON,
  QuoteTestExecutionStateFromJSONTyped,
  QuoteTestExecutionStateToJSON,
  QuoteTestExecutionStateToJSONTyped,
} from "./QuoteTestExecutionState";
import type { QuoteTestExecutionComment } from "./QuoteTestExecutionComment";
import {
  QuoteTestExecutionCommentFromJSON,
  QuoteTestExecutionCommentFromJSONTyped,
  QuoteTestExecutionCommentToJSON,
  QuoteTestExecutionCommentToJSONTyped,
} from "./QuoteTestExecutionComment";

/**
 *
 * @export
 * @interface QuoteTestExecutionDto
 */
export interface QuoteTestExecutionDto {
  /**
   *
   * @type {string}
   * @memberof QuoteTestExecutionDto
   */
  executionId?: string;
  /**
   *
   * @type {string}
   * @memberof QuoteTestExecutionDto
   */
  scenarioId?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof QuoteTestExecutionDto
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof QuoteTestExecutionDto
   */
  createdBy?: string;
  /**
   *
   * @type {QuoteTestExecutionState}
   * @memberof QuoteTestExecutionDto
   */
  state?: QuoteTestExecutionState;
  /**
   *
   * @type {QuoteTestExecutionType}
   * @memberof QuoteTestExecutionDto
   */
  type?: QuoteTestExecutionType;
  /**
   *
   * @type {Array<QuoteTestExecutionExpectation>}
   * @memberof QuoteTestExecutionDto
   */
  successfulExpectations?: Array<QuoteTestExecutionExpectation>;
  /**
   *
   * @type {Array<QuoteTestExecutionExpectation>}
   * @memberof QuoteTestExecutionDto
   */
  failedExpectations?: Array<QuoteTestExecutionExpectation>;
  /**
   *
   * @type {Array<QuoteTestExecutionAudit>}
   * @memberof QuoteTestExecutionDto
   */
  audits?: Array<QuoteTestExecutionAudit>;
  /**
   *
   * @type {Array<string>}
   * @memberof QuoteTestExecutionDto
   */
  errors?: Array<string>;
  /**
   *
   * @type {QuoteTestResult}
   * @memberof QuoteTestExecutionDto
   */
  quote?: QuoteTestResult;
  /**
   *
   * @type {string}
   * @memberof QuoteTestExecutionDto
   */
  metadata?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof QuoteTestExecutionDto
   */
  tags?: Array<string>;
  /**
   *
   * @type {Array<QuoteTestExecutionComment>}
   * @memberof QuoteTestExecutionDto
   */
  comments: Array<QuoteTestExecutionComment>;
  /**
   *
   * @type {Array<QuoteTestExecutionExpectationDto>}
   * @memberof QuoteTestExecutionDto
   */
  success: Array<QuoteTestExecutionExpectationDto>;
  /**
   *
   * @type {Array<QuoteTestExecutionExpectationDto>}
   * @memberof QuoteTestExecutionDto
   */
  failures: Array<QuoteTestExecutionExpectationDto>;
}

/**
 * Check if a given object implements the QuoteTestExecutionDto interface.
 */
export function instanceOfQuoteTestExecutionDto(
  value: object,
): value is QuoteTestExecutionDto {
  if (!("comments" in value) || value["comments"] === undefined) return false;
  if (!("success" in value) || value["success"] === undefined) return false;
  if (!("failures" in value) || value["failures"] === undefined) return false;
  return true;
}

export function QuoteTestExecutionDtoFromJSON(
  json: any,
): QuoteTestExecutionDto {
  return QuoteTestExecutionDtoFromJSONTyped(json, false);
}

export function QuoteTestExecutionDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): QuoteTestExecutionDto {
  if (json == null) {
    return json;
  }
  return {
    executionId: json["executionId"] == null ? undefined : json["executionId"],
    scenarioId: json["scenarioId"] == null ? undefined : json["scenarioId"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    createdBy: json["createdBy"] == null ? undefined : json["createdBy"],
    state:
      json["state"] == null
        ? undefined
        : QuoteTestExecutionStateFromJSON(json["state"]),
    type:
      json["type"] == null
        ? undefined
        : QuoteTestExecutionTypeFromJSON(json["type"]),
    successfulExpectations:
      json["successfulExpectations"] == null
        ? undefined
        : (json["successfulExpectations"] as Array<any>).map(
            QuoteTestExecutionExpectationFromJSON,
          ),
    failedExpectations:
      json["failedExpectations"] == null
        ? undefined
        : (json["failedExpectations"] as Array<any>).map(
            QuoteTestExecutionExpectationFromJSON,
          ),
    audits:
      json["audits"] == null
        ? undefined
        : (json["audits"] as Array<any>).map(QuoteTestExecutionAuditFromJSON),
    errors: json["errors"] == null ? undefined : json["errors"],
    quote:
      json["quote"] == null
        ? undefined
        : QuoteTestResultFromJSON(json["quote"]),
    metadata: json["metadata"] == null ? undefined : json["metadata"],
    tags: json["tags"] == null ? undefined : json["tags"],
    comments: (json["comments"] as Array<any>).map(
      QuoteTestExecutionCommentFromJSON,
    ),
    success: (json["success"] as Array<any>).map(
      QuoteTestExecutionExpectationDtoFromJSON,
    ),
    failures: (json["failures"] as Array<any>).map(
      QuoteTestExecutionExpectationDtoFromJSON,
    ),
  };
}

export function QuoteTestExecutionDtoToJSON(json: any): QuoteTestExecutionDto {
  return QuoteTestExecutionDtoToJSONTyped(json, false);
}

export function QuoteTestExecutionDtoToJSONTyped(
  value?: QuoteTestExecutionDto | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    executionId: value["executionId"],
    scenarioId: value["scenarioId"],
    createdAt: value["createdAt"],
    createdBy: value["createdBy"],
    state: QuoteTestExecutionStateToJSON(value["state"]),
    type: QuoteTestExecutionTypeToJSON(value["type"]),
    successfulExpectations:
      value["successfulExpectations"] == null
        ? undefined
        : (value["successfulExpectations"] as Array<any>).map(
            QuoteTestExecutionExpectationToJSON,
          ),
    failedExpectations:
      value["failedExpectations"] == null
        ? undefined
        : (value["failedExpectations"] as Array<any>).map(
            QuoteTestExecutionExpectationToJSON,
          ),
    audits:
      value["audits"] == null
        ? undefined
        : (value["audits"] as Array<any>).map(QuoteTestExecutionAuditToJSON),
    errors: value["errors"],
    quote: QuoteTestResultToJSON(value["quote"]),
    metadata: value["metadata"],
    tags: value["tags"],
    comments: (value["comments"] as Array<any>).map(
      QuoteTestExecutionCommentToJSON,
    ),
    success: (value["success"] as Array<any>).map(
      QuoteTestExecutionExpectationDtoToJSON,
    ),
    failures: (value["failures"] as Array<any>).map(
      QuoteTestExecutionExpectationDtoToJSON,
    ),
  };
}
